
import React, { useMemo } from 'react';


function countTimeStampReduce(array) {
    if (!Array.isArray(array)) {
        return 0;
    }

    return array.reduce((acc, x) => acc + (x.offSiteTime - x.onSiteTime), 0);
}

function convertMilliseconds(milliseconds) {
    const hours = Math.floor(milliseconds / (1000 * 60 * 60));
    const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((milliseconds % (1000 * 60)) / 1000);
    const remainingMilliseconds = milliseconds % 1000;

    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        milliseconds: remainingMilliseconds
    };
}

function countTimeStampReduceData(array) {
    if (!Array.isArray(array) && array.length > 0) {
        return 0;
    }

    return array.reduce((acc, x) => acc + (x?.endTime - x?.startTime), 0);
}

const Invoice = ({ jobMaterialDetails, viewRowData }) => {
    const newData3 = useMemo(() => viewRowData && viewRowData.assigned_internal_staff_status_m && viewRowData.assigned_internal_staff_status_m.length > 0 ? viewRowData?.assigned_internal_staff_status_m?.reduce((acc, x) => acc + countTimeStampReduce(x.timeData), 0) : viewRowData?.assigned_worker_status?.reduce((acc, x) => acc + countTimeStampReduce(x.timeData), 0), [viewRowData])

    const newData4 = useMemo(() => viewRowData && viewRowData.assigned_internal_staff_status_m && viewRowData.assigned_internal_staff_status_m.length > 0 ? viewRowData?.assigned_internal_staff_status_m?.reduce((acc, x) => acc + countTimeStampReduceData(x.travelLogs), 0) : viewRowData?.assigned_worker_status?.reduce((acc, x) => acc + countTimeStampReduceData(x.travelLogs), 0), [viewRowData])


    const newData1 = useMemo(() => {
        if (!jobMaterialDetails?.MaterialUsed) return [];

        return jobMaterialDetails.MaterialUsed.flatMap(ele =>
            ele?.materials?.map(e => ({
                ...e,
                labour: `${ele?.userId?.first_name} ${ele?.userId?.last_name}`,
                id: e._id // Ensure consistent ID usage
            })) || []
        );
    }, [jobMaterialDetails]);

    const newData2 = useMemo(() => {
        if (!jobMaterialDetails?.MaterialUsed) return [];

        return jobMaterialDetails.MaterialUsed.flatMap(ele =>
            ele?.equipment?.map(e => ({
                ...e,
                labour: `${ele?.userId?.first_name} ${ele?.userId?.last_name}`,
                id: e._id // Ensure consistent ID usage
            })) || []
        );
    }, [jobMaterialDetails]);


    const formatTime = (hours, minutes, seconds) => {
        return `${hours}h ${minutes}m ${seconds}s`;
    };


    return (
        <div style={{ padding: "0 20px", width: '80%', border: "5px solid #2e74b5", margin: "0 auto" }}>
            <div style={{ margin: 'auto', }}>
                <div style={{ display: "flex", justifyContent: "space-between", margin: '20px 0' }}>
                    <img
                        src="./Logo V2.jpg"
                        alt="logo"
                        width={80}
                    />
                    <h1 style={{ paddingRight: "70px" }}>INVOICE</h1>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', textTransform: "capitalize" }}>
                    <div style={{ width: '45%' }}>
                        <p><strong>Company Name: </strong>{viewRowData && viewRowData.assigned_internal_staff_status_m && viewRowData.assigned_internal_staff_status_m.length > 0 ? viewRowData?.created_by?.company_name : viewRowData?.assign_to?.company_name || "N/A"}</p>
                        <p><strong>Job Address: </strong>{`${viewRowData?.location_id?.linecomplete}, ${viewRowData?.location_id?.pin}, ${viewRowData?.location_id?.city}, ${viewRowData?.location_id?.state}` || "N/A"}</p>
                        <p>Tax Registration No.: {jobMaterialDetails?.invoiceDetailsByJobId?.taxRegistrationNo || "N/A"}</p>
                        <p ><strong>Job Title:</strong> {viewRowData?.job_title || "N/A"}</p>
                    </div>
                    <div style={{ width: '50%' }}>
                        <p><strong>Invoice : </strong>#{jobMaterialDetails?.invoiceDetailsByJobId?.invoiceNum || "N/A"}</p>
                        <p><strong>Invoice date:</strong> {jobMaterialDetails?.invoiceDetailsByJobId?.invoiceDate || "N/A"}</p>
                        <p ><strong>ATS Job ID No.: </strong> {viewRowData?.job_id || "N/A"}</p>
                        <p><strong>Bill to: </strong>{`${viewRowData?.created_by?.company_name || "N/A"}`}</p>
                        <p><strong>Address:</strong> {`${viewRowData?.created_by?.address || "N/A"}`}</p>
                        <p><strong>Phone: </strong>{viewRowData?.created_by?.contact || "N/A"}</p>
                    </div>
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Travel Location</th>
                                <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Qty (hours)</th>
                                {<th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Travel Price Type</th>}
                                {jobMaterialDetails?.invoiceDetailsByJobId?.travelPriceType === "Hourly" && <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Travel Rate</th>}
                                <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Travel Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr >
                                <td style={{ border: '1px solid #000', padding: '8px' }}>{`${viewRowData?.location_id?.linecomplete}, ${viewRowData?.location_id?.pin}, ${viewRowData?.location_id?.city}, ${viewRowData?.location_id?.state}` || "N/A"}</td>
                                <td style={{ border: '1px solid #000', padding: '8px' }}>{formatTime(convertMilliseconds(newData4).hours, convertMilliseconds(newData4).minutes, convertMilliseconds(newData4).seconds)}</td>
                                {<td style={{ border: '1px solid #000', padding: '8px' }}>{jobMaterialDetails?.invoiceDetailsByJobId?.travelPriceType || 0}</td>}
                                {jobMaterialDetails?.invoiceDetailsByJobId?.travelPriceType === "Hourly" && <td style={{ border: '1px solid #000', padding: '8px' }}>{jobMaterialDetails?.invoiceDetailsByJobId?.travelRate.toFixed(2) || 0}</td>}
                                <td style={{ border: '1px solid #000', padding: '8px' }}>{Number(jobMaterialDetails?.invoiceDetailsByJobId?.travelPrice).toFixed(2) || 0}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style={{ marginBottom: '20px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Job Details</th>
                                <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Qty (hours)</th>
                                {<th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Job Price Type</th>}
                                {jobMaterialDetails?.invoiceDetailsByJobId?.jobPriceType === "Hourly" && <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Rate</th>}
                                <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr >
                                <td style={{ border: '1px solid #000', padding: '8px' }}>{viewRowData?.job_details}</td>
                                <td style={{ border: '1px solid #000', padding: '8px' }}>{formatTime(convertMilliseconds(newData3).hours, convertMilliseconds(newData3).minutes, convertMilliseconds(newData3).seconds)}</td>
                                {<td style={{ border: '1px solid #000', padding: '8px' }}>{jobMaterialDetails?.invoiceDetailsByJobId?.jobPriceType || 0}</td>}
                                {jobMaterialDetails?.invoiceDetailsByJobId?.jobPriceType === "Hourly" && <td style={{ border: '1px solid #000', padding: '8px' }}>{jobMaterialDetails?.invoiceDetailsByJobId?.jobRate.toFixed(2) || 0}</td>}
                                <td style={{ border: '1px solid #000', padding: '8px' }}>{jobMaterialDetails?.invoiceDetailsByJobId?.jobPrice.toFixed(2) || 0}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style={{ marginBottom: '20px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Materials Description </th>
                                <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Labour</th>
                                <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Qty</th>
                                <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Per Item</th>
                                <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {newData1.length > 0 && newData1.map((material, index) => (
                                <tr key={index}>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>{material.materialDescription}</td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>{material.labour}</td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>{material.qty}</td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>{material?.rate.toFixed(2) || 0}</td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>{material?.price.toFixed(2) || 0}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div style={{ marginBottom: '20px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Equipment Description</th>
                                <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Labour</th>
                                <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Qty</th>
                                <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Per Item</th>
                                <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left', backgroundColor: "#2e74b5", color: 'white' }}>Price</th>
                            </tr> 
                        </thead>
                        <tbody>
                            {newData2.length > 0 && newData2.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>{item.equipmentDescription}</td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>{item.labour}</td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>{item.qty}</td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>{item?.rate.toFixed(2) || 0}</td>
                                    <td style={{ border: '1px solid #000', padding: '8px' }}>{item?.price.toFixed(2) || 0}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div style={{ marginBottom: '20px', display: 'flex', justifyContent: "flex-end" }}>
                    <table style={{ width: '50%', borderCollapse: 'collapse', border: '1px solid #000' }}>
                        <tr>
                            <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #000' }}>Invoice Subtotal:</th>
                            <td style={{ padding: '8px', border: '1px solid #000' }}>{jobMaterialDetails?.invoiceDetailsByJobId?.invoiceSubtotal}</td>
                        </tr>
                        <tr>
                            <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #000' }}>Tax Rate:</th>
                            <td style={{ padding: '8px', border: '1px solid #000' }}>{jobMaterialDetails?.invoiceDetailsByJobId?.taxRate}</td>
                        </tr>
                        <tr>
                            <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #000' }}>Sales Tax:</th>
                            <td style={{ padding: '8px', border: '1px solid #000' }}>{jobMaterialDetails?.invoiceDetailsByJobId?.salesTax}</td>
                        </tr>
                        <tr>
                            <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #000' }}>Deposit Received:</th>
                            <td style={{ padding: '8px', border: '1px solid #000' }}>{jobMaterialDetails?.invoiceDetailsByJobId?.depositReceived}</td>
                        </tr>
                        <tr>
                            <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #000' }}>Total :</th>
                            <td style={{ padding: '8px', border: '1px solid #000' }}>{parseFloat(jobMaterialDetails?.invoiceDetailsByJobId?.invoiceSubtotal + jobMaterialDetails?.invoiceDetailsByJobId?.salesTax - jobMaterialDetails?.invoiceDetailsByJobId?.depositReceived).toFixed(2)}</td>
                        </tr>
                    </table>
                </div>


            </div>
        </div >
    );
};

export default Invoice;
